import { AttachmentUploadPermissions } from '@connect-x-app/shared-domain-models';

import { SUPPORTED_MIME_TYPES } from '../constants';

export const getMimeTypeFromExtension = (extension: string): string | undefined => {
  return SUPPORTED_MIME_TYPES.find(entry => entry.extensions.includes(extension))?.mimeType;
};

export const normalizeAttachmentType = (type: string): string => {
  if (type.startsWith('.')) {
    return getMimeTypeFromExtension(type) ?? type;
  }
  return type;
};

export const isValidFileSignature = (signature: string, mimeType: string): boolean => {
  const mimeTypeEntry = SUPPORTED_MIME_TYPES.find(entry => entry.mimeType === mimeType);
  return mimeTypeEntry?.validFileSignatureCheck(signature) ?? false;
};

export const getValidExtensionsString = (exclude: string[] = [], permissions: string[] = []): string => {
  return SUPPORTED_MIME_TYPES.filter(mimeType => !exclude.some(excludeFileType => mimeType.extensions.includes(excludeFileType)))
    .filter(mimeType => permissions.some(p => mimeType.permissions.includes(p)))
    .map(entry => `${entry.extensions.join(', ')}`)
    .join(', ');
};

export const hasPermissionForFile = (mimeType: string, userPermissions: string[]): boolean => {
  const mimeTypeEntry = SUPPORTED_MIME_TYPES.find(entry => entry.mimeType === mimeType);

  if (mimeTypeEntry) {
    return mimeTypeEntry.permissions.some(requiredPermission => userPermissions.includes(requiredPermission));
  }

  return Object.values(AttachmentUploadPermissions).every(requiredPermission => userPermissions.includes(requiredPermission));
};

// we only do this check on mobile because Android converts image/gif to image/jpg
export const isValidFileType = (fileName: string) => {
  const splittedArray = fileName.split('.');
  return splittedArray.length > 1 && splittedArray[splittedArray.length - 1] !== 'gif';
};

export const toBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
  });
